import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Fade from "@material-ui/core/Fade";
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import Upcomming from "./Upcomming";
import ShortList from "./ShortList";
import UserService from "../../services/user.service";
import { logOut} from "../../helpers/logout";
import {NotificationManager} from "react-notifications";


const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(6),
        [theme.breakpoints.down('xs')]: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(4),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        },
    },
    seeMore: {
        marginTop: theme.spacing(3),
    },
    paper: {
        padding: theme.spacing(3),
        display: 'flex',
        overflow: 'hidden',
        flexDirection: 'column',
        background: '#ffffff',
        borderRadius: 14,
        border: '1px solid rgba(176, 141, 87, 0.18)',
        boxShadow: '0 6px 22px rgba(44, 71, 103, 0.08)',
        position: 'relative',
        transition: 'box-shadow 220ms ease, transform 180ms ease',
        '&:hover': {
            boxShadow: '0 10px 32px rgba(44, 71, 103, 0.12)',
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2.5),
        },
    },
    paperAccent: {
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 3,
            background: 'linear-gradient(90deg, #2c4767 0%, #b08d57 100%)',
            borderTopLeftRadius: 14,
            borderTopRightRadius: 14,
        },
    },
    upcomingCard: {
        minHeight: 320,
        [theme.breakpoints.down('sm')]: {
            minHeight: 'auto',
        },
    },
    listCard: {
        minHeight: 280,
    },
    pageHeader: {
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down('xs')]: {
            marginBottom: theme.spacing(2),
        },
    },
    pageTitle: {
        fontSize: '1.75rem',
        fontWeight: 700,
        color: '#1a2733',
        letterSpacing: '-0.3px',
        margin: 0,
        [theme.breakpoints.up('sm')]: {
            fontSize: '2rem',
        },
    },
    pageSubtitle: {
        color: '#5a6675',
        fontSize: '0.95rem',
        marginTop: 4,
    },
    accentBar: {
        width: 48,
        height: 3,
        background: '#b08d57',
        borderRadius: 2,
        marginTop: 10,
    },
}));

const cardConfig = [
    {
        key: 'pickup',
        title: 'Najbližšie vyzdvihnutia nebohých',
        icon: LocalShippingOutlinedIcon,
    },
    {
        key: 'coffin',
        title: 'Najbližšie príjazdy rakvy',
        icon: PeopleAltOutlinedIcon,
    },
    {
        key: 'funerals',
        title: 'Najbližšie pohreby',
        icon: EventOutlinedIcon,
    },
];

export default function MainPage(props) {
    const classes = useStyles();

    const [closestFunerals, setClosestFunerals] = useState([]);
    const [closestPickUp, setClosestPickUp] = useState([]);
    const [closestCoffin, setClosestCoffin] = useState([]);


    useEffect(() => {
        UserService.getUpcomingFunerals().then(
            (response) => {
                setClosestFunerals(response.data.map((item) => ({
                    funeral_id: item.funeral_id,
                    event_id: item.event_id,
                    deceased: item.deceased,
                    date: item.date,
                    place: item.place,
                    type: item.type
                })));
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
                setClosestFunerals([]);
            }
        );
        UserService.getUpcomingPickUp().then(
            (response) => {
                setClosestPickUp(response.data.map((item) => ({
                    funeral_id: item._id,
                    deceased: item.deceased,
                    date: item.planned_pickup,
                    place: item.planned_pickup_place
                })));
            },
            () => {
                setClosestPickUp([]);
            }
        );
        UserService.getUpcomingCoffin().then(
            (response) => {
                setClosestCoffin(response.data.map((item) => ({
                    funeral_id: item._id,
                    deceased: item.deceased,
                    date: item.coffin_arrival,
                    place: item.coffin_arrival_place
                })));
            },
            () => {
                setClosestCoffin([]);
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const cards = [
        {...cardConfig[0], data: closestPickUp},
        {...cardConfig[1], data: closestCoffin},
        {...cardConfig[2], data: closestFunerals},
    ];

    return (
        <React.Fragment>
            <Container maxWidth="lg" className={classes.container}>
                <Fade in timeout={400}>
                    <div className={classes.pageHeader}>
                        <h1 className={classes.pageTitle}>Domov</h1>
                        <div className={classes.pageSubtitle}>Prehľad najbližších udalostí a posledných pohrebov.</div>
                        <div className={classes.accentBar}/>
                    </div>
                </Fade>
                <Grid container spacing={3}>
                    {cards.map((card, idx) => (
                        <Grid item xs={12} sm={12} md={6} lg={4} key={card.key}>
                            <Fade in timeout={500 + idx * 120}>
                                <Paper className={`${classes.paper} ${classes.paperAccent} ${classes.upcomingCard}`} elevation={0}>
                                    <Upcomming title={card.title} data={card.data} icon={card.icon}/>
                                </Paper>
                            </Fade>
                        </Grid>
                    ))}
                    <Grid item xs={12}>
                        <Fade in timeout={900}>
                            <Paper className={`${classes.paper} ${classes.paperAccent} ${classes.listCard}`} elevation={0}>
                                <ShortList/>
                            </Paper>
                        </Fade>
                    </Grid>
                </Grid>
            </Container>
        </React.Fragment>
    );
}
